// Basic Accessibility Fixes
$(document).ready(function() {
    $('br').attr('aria-hidden','true');
    $('hr').attr('aria-hidden','true');

    // Remove empty Heading
    $('h1, h2, h3, h4, h5, h6').each(function () {
        if ($(this).text().trim() === '') {
            $(this).remove();
        }
    });
});

// color swatches warning on product page
$(document).ready(function () {
// Define the observer callback
  const observerCallback = function (mutationsList, observer) {
    mutationsList.forEach(function (mutation) {
      if (mutation.type === 'childList') {
        $(mutation.addedNodes).each(function () {
          // Check if the added node is the target UL or contains it
          if ($(this).is('ul.swatch-view.swatch-view-custom-image[role="radiogroup"]') ||
              $(this).find('ul.swatch-view.swatch-view-custom-image[role="radiogroup"]').length) {

            $('.form__width .product__form variant-swatch-king .swatches #swatch-group5450447 ul.swatch-view-image[role="radiogroup"], .form__width .product__form variant-swatch-king .swatches #swatch-group3978770 ul.swatch-view-custom-image').each(function () {
              if (!$(this).attr('aria-label')) {
                $(this).attr(
                  'aria-label',
                  'Choose a color. Product will refresh the page' 
                );
              }
            });
          }
        });
      }
    });
  };

  // Create the observer instance
  const observer = new MutationObserver(observerCallback);

  // Start observing the body for child node additions
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});



//shop the button dialog fixed
$(document).ready(function() {
  $('#shop-the-room-button').on('click', function() {
    $('.px-look-drawer-close').focus();
  });

  $('.px-look-drawer-close').on('click', function() {
    $('#shop-the-room-button').focus();
  });
});


//shop the button pop up aria-state updated
$(document).ready(function() {
  function updateAriaHidden() {
    const $drawer = $('#drawer-template--18987291869357__shop_the_room_Rm43wa');

    if ($drawer.hasClass('px-look-drawer')) {
      $drawer.attr('aria-hidden', 'true');
    }

    if ($drawer.hasClass('active')) {
      $drawer.attr('aria-hidden', 'false');
    } else {
      $drawer.attr('aria-hidden', 'true');
    }
  }

  // Run once on load
  updateAriaHidden();

  // Optionally re-run on class change
  const observer = new MutationObserver(updateAriaHidden);
  observer.observe(document.getElementById('drawer-template--18987291869357__shop_the_room_Rm43wa'), {
    attributes: true,
    attributeFilter: ['class']
  });
});

// hidden content remove after header
$(document).ready(function () {
  // Check if it's desktop view (e.g., width >= 1024px)
  if ($(window).width() >= 769) {
    $('.search-popdown').remove();
  }
});

